import React from 'react';
import { Lightning } from '@phosphor-icons/react';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { APPLY_AUTOFILL_COOKIE } from '../../utils/feature-flags/apply-autofill-flag';
import { shouldShowQuickApplyBadge } from '../../utils/quick-apply/quick-apply';
import { useFormatMessage } from '../../i18n-review/client/Msg';

/**
 * TEC-717: small "Quick apply" pill for jobs whose ATS supports application autofill. Renders
 * nothing unless the vendor is launched (or the viewer has the dev cookie), so production shows
 * nothing until a vendor passes the manual test pass. Shown to everyone, signed in or not.
 */
export function QuickApplyBadge({ atsVendor, className = '' }: { atsVendor?: string | null; className?: string }) {
  const formatMessage = useFormatMessage();
  const hasDevCookie = useFeatureFlag(APPLY_AUTOFILL_COOKIE);
  if (!shouldShowQuickApplyBadge(atsVendor, hasDevCookie)) return null;
  const label = formatMessage({
    id: 'quickApply.badge',
    defaultMessage: 'Quick apply',
    description: 'Small pill on a job card or job page for jobs where JobCrawls can fill in the application form for you',
  });
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-jc-accent-muted px-1.5 py-0.5 text-xs font-bold uppercase tracking-wide text-jc-accent ${className}`.trim()}
      data-testid="quick-apply-badge"
    >
      <Lightning size={10} weight="fill" aria-hidden="true" />
      {label}
    </span>
  );
}
